//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/popup'
import { RequiredRule, NumericRule, RangeRule, StringLengthRule, CustomRule, CompareRule, PatternRule, EmailRule, AsyncRule } from 'devextreme/ui/validation_engine'

//#endregion

import { Enums } from '../../../models/common'
import { Api, LocalDictionaryFactory } from './../../api/api.module'
import { PasswordResetModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { Md5 } from '../../../helpers/md5-helper'
import { IUserSession } from '../../../helpers/user-session'
import { PasswordPolicyRules } from '../../../models/custom/password-policy-rulles'
import { OperatorSecurityService, OPERATOR_SECURITY_SERVICE_NAME } from '../../../services/operator'
import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { TypeHelper } from '../../../helpers'

//#region Asset Imports

import './change-password.scss'
import * as TEMPLATE from './change-password.tpl.html'

//#endregion

interface ChangePasswordScope extends ng.IScope {
	id: number

	popupOptions: DevExpress.ui.dxPopupOptions
	popupVisible: boolean

	formOptions: DevExpress.ui.dxFormOptions
	formItems: any
	formData: any
	formInstance: any

	cancelBtnOptions: DevExpress.ui.dxButtonOptions
	saveBtnOptions: DevExpress.ui.dxButtonOptions

	showError: any
}

export class ChangePasswordDirective implements ng.IDirective {
	private previousPasswordMd5: string
	private previousChangeFailed: boolean = false
	constructor() {}

	restrict = 'E'
	scope = true

	controller = [
		$SCOPE_SERVICE_NAME,
		$Q_SERVICE_NAME,
		'api',
		'localDictionary',
		USER_SESSION_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		($scope: ChangePasswordScope, $q: ng.IQService, api: Api, localDictionary: LocalDictionaryFactory, userSession: IUserSession, operatorSecurityService: OperatorSecurityService) => {
			$scope.popupVisible = false
			$scope.formInstance = {}

			const deferred: JQueryDeferred<PasswordPolicyRules> = $.Deferred<PasswordPolicyRules>()
			operatorSecurityService.getPasswordPolicyRules().then((rules: PasswordPolicyRules) => {
				deferred.resolve(rules)
			})

			$scope.popupOptions = {
				bindingOptions: {
					visible: 'popupVisible',
					title: 'popupOptions.title',
				},
				maxWidth: 400,
				height: 'auto',
				showTitle: true,
				closeOnOutsideClick: true,
				onHidden: () => {
					onPopupHidden()
				},
				onShowing: () => {
					this.previousPasswordMd5 = ''
				},
			}

			const onPopupHidden = () => {
				$scope.formInstance.resetValues()
				$scope.showError = null
			}

			$scope.cancelBtnOptions = {
				text: i18n('Common', 'Cancel'),
				onClick: () => {
					$scope.popupVisible = false
				},
				height: 36,
			}

			$scope.saveBtnOptions = {
				text: i18n('Common', 'Apply'),
				type: 'normal',
				onClick: () => {
					submitPasswordChange($scope.formData)
				},
				height: 36,
			}

			$scope.$on(EventsNames.OPEN_PASSWORD_CHANGE_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
				$scope.popupVisible = true
				$scope.popupOptions.title = i18n('Popup', 'ChangePassword')

				deferred.promise().then((passwordRules: PasswordPolicyRules) => {
					console.warn('PASSWORD RULLE', passwordRules)

					$scope.formItems = [
						{
							dataField: 'OldPassword',
							label: {
								text: i18n('Common', 'OldPassword'),
							},
							isRequired: true,
							editorOptions: {
								mode: 'password',
							},
							validationRules: [CommonHelper.requiredField()],
						},
						{
							dataField: 'NewPassword',
							label: {
								text: i18n('Common', 'NewPassword'),
							},
							isRequired: true,
							editorOptions: {
								mode: 'password',
							},
							validationRules: getValidationRulesForNewPassword(passwordRules),
						},
						{
							dataField: 'ConfirmNewPassword',
							label: {
								text: i18n('Common', 'ConfirmNewPassword'),
							},
							isRequired: true,
							editorOptions: {
								mode: 'password',
							},
							validationRules: [CommonHelper.requiredField(), CommonHelper.compareField(comparisonTargetNew)],
						},
					]

					$scope.formData = []

					if (!$scope.formOptions) {
						$scope.formOptions = {
							formData: $scope.formData,
							items: $scope.formItems,
							onInitialized: initializedHandler,
							onOptionChanged: optionChangedHandler,
						}
					} else {
						$scope.formInstance.option('formData', $scope.formData)
					}
				})
			})

			const getValidationRulesForNewPassword = (rules: PasswordPolicyRules): RequiredRule[] => {
				const validationRules: RequiredRule[] = [CommonHelper.requiredField()]

				if (rules.minLength > 0) {
					validationRules.push(CommonHelper.minLenghtField(rules.minLength))
				}

				if (rules.minDigitsCount > 0) {
					validationRules.push(CommonHelper.minNumbersField(rules.minDigitsCount))
				}

				if (rules.minLowerLettersCount > 0) {
					validationRules.push(CommonHelper.minLowerCaseField(rules.minLowerLettersCount))
				}

				if (rules.minSpecialSymbolsCount > 0) {
					validationRules.push(CommonHelper.minSpecialSymbolsField(rules.minSpecialSymbolsCount))
				}

				if (rules.minUpperLettersCount > 0) {
					validationRules.push(CommonHelper.minUpperCaseField(rules.minUpperLettersCount))
				}

				return validationRules
			}

			const comparisonTargetNew = () => {
				if ($scope.formData['NewPassword']) {
					return $scope.formData['NewPassword']
				}
			}

			const initializedHandler = (e) => {
				$scope.formInstance = e.component
			}

			const optionChangedHandler = (e) => {
				$scope.formInstance = e.component
				$scope.formInstance.repaint()
			}

			const submitPasswordChange = (fields) => {
				const result = $scope.formInstance.validate()
				if (result.isValid) {
					var oldPassword = fields['OldPassword']
					var newPassword = fields['NewPassword']
					var confirmNewPassword = fields['ConfirmNewPassword']

					if (newPassword === confirmNewPassword) {
						//send oldPass and newPass to service
						var model = new PasswordResetModel()
						model.password = newPassword
						model.oldPassword = oldPassword
						model.locale = userSession.getDataProvider().System.getCurrentLanguage()
						var currentMd5 = Md5.init(model)
						if (this.previousPasswordMd5 !== currentMd5 || this.previousChangeFailed) {
							this.previousPasswordMd5 = currentMd5
							api.users
								.changePassword(model)
								.then((request) => {
									if (request.status != 'OK') {
										$scope.showError = request.message
										this.previousChangeFailed = true
									} else if (request.status == 'OK' && (!request.hasErrorCode || request.hasErrorCode <= 0)) {
										CommonHelper.openInfoPopup(request.message)
										$scope.popupVisible = false
										this.previousChangeFailed = false
									}
								})
								.catch((err) => {
									this.previousChangeFailed = true
									console.log(err)
								})
						}
					}
				}
			}
		},
	]
	template = TEMPLATE
	transclude = true
}
